// extracted by mini-css-extract-plugin
export var filterIncDec = "_51-0";
export var leftBorder = "_51-1";
export var rightBorder = "_51-2";
export var stringInput = "_51-3";